import { DateTime } from 'luxon';
const convertToTz = (value) => {
    const dtObj = DateTime.local({ locale: 'fr', zone: value });
    DateTime.now().toMillis();
    return {
        label: value.split('/').join(' - ').split('_').join(' '),
        value,
        currentOffset: dtObj.zone.offset(DateTime.now().toMillis()),
        utcOffsetString: dtObj.zone.formatOffset(DateTime.now().toMillis(), 'short'),
        isInDST: dtObj.isInDST,
    };
};
const getDefaultTimezone = () => convertToTz(Intl.DateTimeFormat().resolvedOptions().timeZone);
const getAllTimezones = () => {
    //@ts-ignore not supported by our version of typescript for now
    return Intl.supportedValuesOf('timeZone').map(convertToTz);
};
export const useTimezone = () => {
    return {
        getAllTimezones,
        convertToTz,
        getDefaultTimezone,
    };
};
